module.exports = __webpack_public_path__ + "static/media/ins13.48f59fed.jpg";